import { isDefined } from "@opendaw/lib-std";
export var ScriptMeta;
(function (ScriptMeta) {
    ScriptMeta.init = (name = "Untitled", description = "") => {
        const created = new Date().toISOString();
        return { name, description, created, modified: created };
    };
    ScriptMeta.copy = (meta) => Object.assign({}, meta);
    ScriptMeta.fromJSON = (json) => {
        if (!isDefined(json) || typeof json !== "object" || Array.isArray(json)) {
            return ScriptMeta.init();
        }
        return Object.assign(ScriptMeta.init(), json);
    };
})(ScriptMeta || (ScriptMeta = {}));
